import { Directive, ElementRef, Renderer2, HostListener, Output, EventEmitter } from '@angular/core';
import { ThousandPipe } from '../../pipes/thousand.pipe'

@Directive({
  selector: '[CurrencyDirective][ngModel]'
})
export class CurrencyDirective {


  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  constructor(private el: ElementRef, private thousandPipe: ThousandPipe,
    private render: Renderer2) { }

  @HostListener('keyup', ['$event']) onInputChange(event) {
    // get position
    let pos = this.el.nativeElement.selectionStart;

    let check = false;


    let oldVal = this.el.nativeElement.value;
    let newVal = "";

    if (event.keyCode === 188 && oldVal.length === pos && oldVal[oldVal.length - 2] !== ",") { // "Comma for decimals"
      newVal = oldVal;
    } else {
      newVal = this.thousandPipe.transform(parseFloat(oldVal.split(".").join("").split(",").join(".")), 'es')
    }

    this.render.setProperty(this.el.nativeElement, 'value', newVal);
    this.ngModelChange.emit(newVal);

    if (newVal.length != oldVal.length) {
      this.el.nativeElement.setSelectionRange(pos + 1, pos + 1, 'none');
    } else {
      this.el.nativeElement.setSelectionRange(pos, pos, 'none');
    }

  }
}